import { render, staticRenderFns } from "./tab-new.vue?vue&type=template&id=c454c162&scoped=true&"
import script from "./tab-new.vue?vue&type=script&lang=js&"
export * from "./tab-new.vue?vue&type=script&lang=js&"
import style0 from "./tab-new.vue?vue&type=style&index=0&id=c454c162&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c454c162",
  null
  
)

export default component.exports